/* eslint-disable */

export default {
  name: 'PayHandle',
  created() {
    console.error('->', this.$route.query)
    let result = this.$route.query
    this.success = result.r === '1'
    this.orderNo = result.orderNo
    if (this.success) {
      this.msg = '付款成功'
    } else {
      this.errMsg = decodeURIComponent(decodeURIComponent(result.msg)) || ''
    }

    let _this = this;
    let downTime = setInterval(() => {
      _this.count--;
      if (_this.count == 0) {
        clearInterval(downTime);
        this.close();
      }
    }, 1000)
  },
  data() {
    return {
      success: false,
      msg: '付款失敗',
      errMsg: '',
      count: 15,
      orderNo: ''
    }
  },
  methods: {
    close() {
        window.location.href = '/pay'
    }
  }
}